import { render, staticRenderFns } from "./CCMConsentFormViewDialog.vue?vue&type=template&id=880d07ec"
import script from "./CCMConsentFormViewDialog.vue?vue&type=script&lang=js"
export * from "./CCMConsentFormViewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports